export default "/signup/_next/static/chunks/fonts/lineto-circular-book-f28da8d8c895486dfb4e0aab09de1ee6.woff";